import React from "react";
import { nanoid } from "nanoid";

export const HalfCircularGauge = ({ value, max, gradientFrom, gradientTo }) => {
  const gradientId = nanoid();
  const percentage = (value / max) * 100;

  return (
    <div className="w-full max-w-xs mx-auto relative">
      <svg viewBox="0 0 200 100" className="w-20 h-auto mx-auto">
        {/* Background arc */}
        <path
          d="M10,100 A90,90 0 0,1 190,100"
          fill="none"
          stroke="#E5E8EC"
          strokeWidth="10"
        />

        {/* Foreground arc (value) */}
        <path
          d="M10,100 A90,90 0 0,1 190,100"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="20"
          strokeDasharray="283"
          strokeDashoffset={283 - (283 * percentage) / 100}
        />

        {/* Gradient Definition */}
        <defs>
          <linearGradient
            id={gradientId}
            x1="51.0002"
            y1="0.500017"
            x2="51.0002"
            y2="24.5964"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradientFrom} />
            <stop offset="1" stopColor={gradientTo} />
          </linearGradient>
        </defs>
      </svg>

      {/* Value Text */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-base font-bold text-gray-700">
        {value}
      </div>

      {/* Min and Max Labels */}
      <div className="absolute -bottom-4 left-2 text-sm text-gray-500">0</div>
      <div className="absolute -bottom-4 right-2 text-sm text-gray-500">
        {max}
      </div>
    </div>
  );
};
